export default {
	title: 'Elementi disabilitati',
	empty: 'Nessun elemento disabilitato in questo scenario',
	no_scenario: 'Seleziona uno scenario per vedere gli elementi disabilitati'
};

